import { Button, Card, Col, Row } from "react-bootstrap"
import PageTitle from "../PageTitle";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import axiosInstance from "../../../services/AxiosInstance";
import { errorAlert } from "../../components/alert/defaultAlert";
import "./NewPage.css";

/**
 * @param {string} motherMenu - Módulo ao qual pertence o componente.
 * @param {string} childMenu - Componente do módulo.
 * @param {string} activeMenu - Menu ativo do componente.
 * @param {object} path - Path que irá se comunicar via api.
 * @param {object} setEntityData - Armazena o recurso recuperado da api.
 */
const NewPage = (props) => {

    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { saveButtonText, saveButtonIcon, hideSaveButton, hideCancelButton } = props;

    const handleCancel = () => {
        navigate(props.cancelRoute);
    }

    useEffect(() => {
        if (id !== undefined && props.path && typeof props.setEntityData === 'function') {
            // Busca os dados e repassa para o componente pai.
            axiosInstance.get(props.path + "/" + id)
                .then(resp => {
                    props.setEntityData(resp.data);
                })
                .catch(error => errorAlert(error));
        }

        // eslint-disable-next-line
    }, [id]);

    return (
        <>
            <PageTitle activeMenu={props.activeMenu} childMenu={props.childMenu} motherMenu={props.motherMenu} />
            <Card className="new-page-card">
                <Card.Body>
                    <Row>
                        <Col xl={12}>
                            <form onSubmit={props.handleSubmit}>
                                {props.child}

                                <div className="new-page-actions">
                                    {
                                        // Mantém os botões em uma área própria para garantir o mesmo
                                        // espaçamento e altura em todos os formulários baseados no NewPage.
                                        (hideSaveButton !== undefined && hideSaveButton) ?
                                            <></>
                                            :
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                disabled={props.isSubmitting}>
                                                {!saveButtonIcon ? '' : <>{saveButtonIcon} {' '}</>}{!saveButtonText ? t('save') : saveButtonText}
                                            </Button>
                                    }

                                    {
                                        hideCancelButton ? null :
                                            <Button
                                                variant="light"
                                                disabled={props.isSubmitting}
                                                onClick={handleCancel}>
                                                {t('cancel')}
                                            </Button>
                                    }

                                    {(props.customButtons) ? props.customButtons : <></>}
                                </div>
                            </form>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </>
    )
}

export default NewPage;
